import { useEffect, useRef } from "react";

/**
 * A hook which gets the previous value of a state field, as it was set before the current render (or the current value on the first render).
 * @param value The state value to track.
 */
function usePrevious<TValue>(value: TValue): TValue {
    // This works by creating a reference (ref) which persists for the lifetime of the component,
    // which keeps a copy of the last value that was set. The useEffect only applies *after* the
    // current render, so calling usePrevious always returns the value that was passed in before
    // the current render (except on first initialization).

    const ref = useRef<TValue>(value);

    useEffect(
        () => {
            ref.current = value;
        },
        [value]
    );

    return ref.current;
}

export { usePrevious };
